var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNameIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6406_1944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3C7.808 3 4 6.808 4 11.5C4 16.192 7.808 20 12.5 20C17.192 20 21 16.192 21 11.5C21 6.808 17.192 3 12.5 3ZM8.3095 16.838C8.675 16.073 10.902 15.325 12.5 15.325C14.098 15.325 16.3335 16.073 16.6905 16.838C15.5345 17.756 14.081 18.3 12.5 18.3C10.919 18.3 9.4655 17.756 8.3095 16.838ZM17.906 15.6055C16.6905 14.1265 13.741 13.625 12.5 13.625C11.259 13.625 8.3095 14.1265 7.094 15.6055C6.227 14.4665 5.7 13.047 5.7 11.5C5.7 7.7515 8.7515 4.7 12.5 4.7C16.2485 4.7 19.3 7.7515 19.3 11.5C19.3 13.047 18.773 14.4665 17.906 15.6055ZM12.5 6.4C10.851 6.4 9.525 7.726 9.525 9.375C9.525 11.024 10.851 12.35 12.5 12.35C14.149 12.35 15.475 11.024 15.475 9.375C15.475 7.726 14.149 6.4 12.5 6.4ZM12.5 10.65C11.7945 10.65 11.225 10.0805 11.225 9.375C11.225 8.6695 11.7945 8.1 12.5 8.1C13.2055 8.1 13.775 8.6695 13.775 9.375C13.775 10.0805 13.2055 10.65 12.5 10.65Z",
    fill: "#0E0063"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6406_1944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/name_icon.a058f558198e87dd826e04fcb271e53a.svg";
export { ForwardRef as ReactComponent };